import { render, staticRenderFns } from "./CrearEnvioInformacionModal.vue?vue&type=template&id=48e27e05&"
import script from "./CrearEnvioInformacionModal.vue?vue&type=script&lang=ts&"
export * from "./CrearEnvioInformacionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports